// Ported from case-desk src/app/RouteHydrateFallback.tsx (commit 1d18e32), 2026-08-18
import { useTranslation } from 'react-i18next';

import { BootstrapLoadingScreen } from '../components/BootstrapLoadingScreen';

export function RouteHydrateFallback() {
  const { t } = useTranslation();

  return <BootstrapLoadingScreen label={t('common.loading')} />;
}
